if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.toggleAnimatedGraphicButton = this.querySelector('.toggle-thumbnail-animation') || null;
        if (this.toggleAnimatedGraphicButton) {
          this.toggleAnimatedGraphicButton.addEventListener('click', this.handleAnimatedGraphicToggle.bind(this));
        }

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });

        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();

        this.initVariantImages();
      }

      initVariantImages() {
        const currentVariant = {title: this.getAttribute("data-selected-variant")}
        const numberOfVariants = parseInt(this.getAttribute("data-number-of-variants"));

        numberOfVariants > 1 && this.setVariantMedia(currentVariant);
      }

      handleAnimatedGraphicToggle() {
        const animatedThumbnails = this.elements.thumbnails.querySelectorAll('.thumbnail--gif');
        animatedThumbnails.forEach((thumbnail) => {
          thumbnail.classList.toggle('hidden');
        });

        const isHidden = animatedThumbnails[0].classList.contains('hidden');
        this.toggleAnimatedGraphicButton.innerHTML = isHidden ? '<svg width="10px" height="10px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#101820"><g stroke-width="0"></g><g stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill="none" stroke="#101820" stroke-width="2" d="M3,22.0000002 L21,12 L3,2 L3,22.0000002 Z M5,19 L17.5999998,11.9999999 L5,5 L5,19 Z M7,16 L14.1999999,12 L7,8 L7,16 Z M9,13 L10.8,12 L9,11 L9,13 Z"></path> </g></svg> Show Animated Graphic' : '<svg width="10px" height="10px" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M7 1H2V15H7V1Z" fill="#101820"></path> <path d="M14 1H9V15H14V1Z" fill="#101820"></path> </g></svg> Hide Animated Graphic'; 
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
        this.announceLiveRegion(event.detail.currentElement, event.detail.currentElement.getAttribute('aria-label'));
      }

      setVariantMedia(currentVariant) {
        const currentVariantHandle = handleize(currentVariant.title);
        const variantImagesReadyFroGrouping = this.getAttribute("data-variant-images-ready-for-grouping") === "true";

        variantImagesReadyFroGrouping && 
        this.elements.viewer.querySelectorAll(".product__media-item").forEach(element => 
          this.handleVariantMediaVisibility(currentVariantHandle, element)
        );

        if (this.elements.viewer.slider) this.elements.viewer.resetPages();

        if (this.elements.thumbnails) {
          variantImagesReadyFroGrouping && 
          this.elements.thumbnails.querySelectorAll(".thumbnail-list__item").forEach(element =>
            this.handleVariantMediaVisibility(currentVariantHandle, element)
          );
          
          if (this.elements.thumbnails.slider) this.elements.thumbnails.resetPages();
        }
      }

      handleVariantMediaVisibility(currentVariantHandle, element) {
        if (element.getAttribute(`data-variant-${currentVariantHandle}`) !== null) {
          element.classList.remove("hidden");
        } else {
          element.classList.add("hidden");
        }
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');

        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
            activeMedia.scrollIntoView({ behavior: 'smooth' });
          }
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          // setTimeout(() => {
          //   this.elements.liveRegion.setAttribute('aria-hidden', true);
          // }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        // window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
